import { createSlice, PayloadAction } from '@reduxjs/toolkit'; 
import { AppThunk } from 'app/store/store';
import { steemCustomApi } from 'services/dsteem-service'; 
import { getContent } from 'services/posts-service';
// import { post as postService } from 'services/api-service';
// Máx depth of replies
const MAX_REPLY_DEPTH = 5;
type RepliesState = {
  replies: any, 
  isLoadingReplies: boolean
  error: string | null,
  scrollPosition: number | null;
}

const repliesInitialState: RepliesState = {
  replies: null, 
  isLoadingReplies: true,
  error: null,
  scrollPosition:null
}

function startLoading(state: RepliesState) {
  state.isLoadingReplies = true
}

function loadingFailed(state: RepliesState, action: PayloadAction<string>) {
  state.isLoadingReplies = false
  state.error = action.payload
}

const replies = createSlice({
  name: 'replies',
  initialState: repliesInitialState,
  reducers: {
    getRepliesStart: startLoading,
    getRepliesSuccess(state, { payload }: PayloadAction<any>) {
      state.isLoadingReplies = false
      state.error = null
      state.replies = payload.replies
      state.scrollPosition = payload.scrollPosition ?? null;
    },
    getRepliesFailure: loadingFailed,
    resetScrollPosition: (state) => { // Opcional: Para resetear la posición después de usarla
      state.scrollPosition = null;
    },
  }
});

export const {
  getRepliesStart,
  getRepliesSuccess,
  getRepliesFailure,
  resetScrollPosition,
} = replies.actions;

export default replies.reducer; 
export const fetchReplyWithVotes = async (reply: any) => {
  try {
    const clonedReply = { ...reply };
 
    const content = await getContent(reply.author, reply.permlink);
    if (content) {
      clonedReply.active_votes_modified = content.active_votes || [];
    } 
    return clonedReply;
  } catch (error) {
    console.log("While fetching votes",error); 
    return reply;
  }
  
};


const fetchRepliesRecursive = async (
  author: string,
  permlink: string,
  depth: number = 1
): Promise<any[]> => {
  if (depth > MAX_REPLY_DEPTH) return [];

  const replies = await steemCustomApi('condenser_api.get_content_replies', [author, permlink]);

  const result = [];

  for (const reply of replies) {
    const replyWithVotes = await fetchReplyWithVotes(reply); 
    result.push(replyWithVotes);

    const childReplies = await fetchRepliesRecursive(reply.author, reply.permlink, depth + 1);
    result.push(...childReplies);
  }

  return result;
};
export const fetchReplies = (
  author: string,
  permlink: string,
  scrollPosition?: number
): AppThunk => async (dispatch) => {
  try {
    dispatch(getRepliesStart());

    const allReplies = await fetchRepliesRecursive(author, permlink);

    dispatch(getRepliesSuccess({ replies: allReplies, scrollPosition }));
  } catch (err) {
    dispatch(getRepliesFailure(err.toString()));
  }
};
export const getPost = getContent;